<template>
<div class="chapter">
<div class="inner_page">
<p class="chapter_head_note"><a id="page_5"></a>“I believe in <em>living</em> with the camera, and not <em>using</em> the camera. Suddenly, if you are working a lot, it takes over and then you see meaning in everything. You don’t have to push for it. That’s what I mean by the visual life. Very rare.”<sup><a href="#/xhtml/21endnotes#ien1" id="en1">1</a></sup></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06-frontmattera.vue?082ab3dc